import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './feed-profit.actions';
import {
  Calculation,
  ExtendedSimulation,
  FeedProfitModuleState,
} from '../models/feed-profit.model';

function selectIdNumber(c: Calculation): number {
  return c.id;
}
export const adapter: EntityAdapter<Calculation> = createEntityAdapter<Calculation>({
  selectId: selectIdNumber,
});

export const initialState = <FeedProfitModuleState>{
  calculation: adapter.getInitialState([]),
  calculations: null,
  selectedCalculationId: 0,
  selectedCalculation: null,
  isLoaded: false,
  isChanged: false,
};

const feedProfitReducer = createReducer(
  initialState,
  on(actions.clearFeedProfitState, (state) => ({
    ...state,
    isLoaded: false,
    isChanged: false,
    selectedCalculationId: 0,
    selectedCalculation: null as Calculation,
    calculations: null as Calculation[],
  })),
  on(actions.loadCalculationsSuccess, (state, { calculations }) => ({
    ...state,
    calculations,
    selectedCalculationId: 0,
    selectedCalculation: null as Calculation,
    isLoaded: true,
    isChanged: false,
  })),
  on(actions.setSelectedCalculationSuccess, (state, { calculation }) => ({
    ...state,
    selectedCalculationId: calculation.id,
    selectedCalculation: calculation,
    simulations: calculation.quickSimulations,
  })),
  on(actions.setNavigateCalculationSuccess, (state, { calculationId }) => ({
    ...state,
    selectedCalculationId: calculationId,
    selectedCalculation: state.calculations.find((c) => c.id === calculationId),
    simulations: state.calculations.find((c) => c.id === calculationId).quickSimulations,
  })),
  on(actions.deleteCalculationSuccess, (state, { calculationId }) => ({
    ...state,
    selectedCalculationId: 0,
    selectedCalculation: null as Calculation,
    calculations: [...state.calculations.filter((c) => c.id !== calculationId)],
    simulations: state.calculations.find((c) => c.id === calculationId).quickSimulations,
  })),
  on(actions.setIsChanged, (state, { isChanged }) => ({
    ...state,
    isChanged,
  })),
  on(actions.updateSelectedCalculation, (state, { values }) => {
    let extendedSimulation = <ExtendedSimulation>state.selectedCalculation?.extendedSimulation;

    // Only update if we have new values, or have old values to re set.
    if (values.extendedSimulation || state.selectedCalculation?.extendedSimulation) {
      extendedSimulation = {
        ...state.selectedCalculation?.extendedSimulation,
        genders: values.extendedSimulation?.genders
          ? values.extendedSimulation.genders
          : state.selectedCalculation?.extendedSimulation?.genders,
        country: values.extendedSimulation?.country
          ? values.extendedSimulation.country
          : state.selectedCalculation?.extendedSimulation?.country,
        feeders: values.extendedSimulation?.feeders
          ? values.extendedSimulation.feeders
          : state.selectedCalculation?.extendedSimulation?.feeders,
        calculatedFeeder:
          values.extendedSimulation?.calculatedFeeder != null
            ? values.extendedSimulation?.calculatedFeeder
            : state.selectedCalculation?.extendedSimulation?.calculatedFeeder,
        baseLine: values.extendedSimulation?.baseLine
          ? values.extendedSimulation.baseLine
          : state.selectedCalculation?.extendedSimulation?.baseLine,
        extendedBaseLine: values.extendedSimulation?.extendedBaseLine
          ? values.extendedSimulation.extendedBaseLine
          : state.selectedCalculation?.extendedSimulation?.extendedBaseLine,
      };
    }

    return {
      ...state,
      selectedCalculation: <Calculation>{
        ...state.selectedCalculation,
        name: values.name ? values.name : state.selectedCalculation?.name,
        country:
          !!values.country || values.country?.length === 0
            ? values.country
            : state.selectedCalculation?.country,
        genders:
          !!values.genders || values.genders?.length === 0
            ? values.genders
            : state.selectedCalculation?.genders,
        feeders: values.feeders ? values.feeders : state.selectedCalculation?.feeders,
        calculatedFeeder: values.calculatedFeeder
          ? values.calculatedFeeder
          : state.selectedCalculation?.calculatedFeeder,
        companyDetails: values.companyDetails
          ? values.companyDetails
          : state.selectedCalculation?.companyDetails,
        baseLine: values.baseLine ? values.baseLine : state.selectedCalculation?.baseLine,
        extendedBaseLine: values.extendedBaseLine
          ? values.extendedBaseLine
          : state.selectedCalculation?.extendedBaseLine,
        quickSimulations: values.quickSimulations
          ? values.quickSimulations
          : state.selectedCalculation?.quickSimulations,
        comparisonSimulation:
          values.comparisonSimulation !== undefined
            ? values.comparisonSimulation
            : state.selectedCalculation?.comparisonSimulation,
        extendedSimulation,
      },
    };
  }),
);

export function reducer(state: FeedProfitModuleState | undefined, action: Action) {
  return feedProfitReducer(state, action);
}
